import { RoundSlider } from "mz-react-round-slider";
import { useState } from "react";

const CircleSlider = ({
  value,
  setValue,
  isDisable,
  setShouldPublishMessage,
  shouldPublishMessage,
}) => {
  const [pointers, setPointers] = useState([{ value: 10 }]);

  const handleSliderChange = (newValue) => {
    setValue(newValue);
  };

  return (
    <RoundSlider
      pathStartAngle={180}
      pathEndAngle={0}
      textColor={"#8993B7"}
      pathThickness={20}
      pathRadius={95}
      min={10}
      max={40}
      disabled={isDisable}
      step={0.5}
      arrowStep={0.5}
      round={1}
      pointers={value}
      textOffsetX={0}
      textOffsetY={-25}
      onChange={handleSliderChange}
    />
  );
};

export default CircleSlider;
